import { render, staticRenderFns } from "./blank.vue?vue&type=template&id=3c63e96e&scoped=true&"
import script from "./blank.vue?vue&type=script&lang=js&"
export * from "./blank.vue?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=3c63e96e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c63e96e",
  null
  
)

export default component.exports